import { Dropdown } from "react-bootstrap";
import React from "react";
import Context from "../../../Context";

export default class TrackerAddButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }
  onOpen = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ show: true });
  };
  onFinish = (e) => {
    this.setState({ show: false });
    if (this.props.onFinish) {
      this.props.onFinish(e);
    }
  };

  render() {
    return (
      <>
        <Dropdown>
          <Dropdown.Toggle as={DropdownToggle} id="dropdown-actions">
            <i className="flaticon2-add-1 p-0 align-middle text-muted"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <ActionsList
              onClick={this.onFinish}
              itemId={this.props.itemId}
              types={this.props.types}
            />
          </Dropdown.Menu>
        </Dropdown>
      </>
    );
  }
}

class ActionsList extends React.Component {
  static contextType = Context;

  render() {
    let typeList = this.props.types || [];
    return (
      <>
        {typeList.length > 0 ? (
          <div>
            {typeList.map((t) => {
              return (
                <span
                  onClick={() => this.props.onClick(t.code)}
                  className="btn w-100 text-hover-primary"
                  key={t.id}
                >
                  {t.name}
                </span>
              );
            })}
          </div>
        ) : null}
      </>
    );
  }
}

const DropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span
    ref={ref}
    title="Добавить"
    className="btn btn-icon btn-light  text-hover-primary"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));
